import type { DrugImage, DrugImageInfo } from '@/api/domains/drugs.types';
import { type GalleryImageInfo } from '@/components/Gallery/types';

export const convertGalleryToDrugImages = (galleryImages: GalleryImageInfo[]): DrugImageInfo[] =>
  galleryImages.map(image => ({
    id: image.id,
    image_url: image.url,
    image_token: image.token,
    position: image.position,
  }));

export const convertDrugToGalleryImages = (drugImages: DrugImage[]): GalleryImageInfo[] =>
  drugImages.map(image => ({
    id: image.id,
    url: image.image_url,
    position: image.position,
    token: image.image_token,
  }));
